export const mensagemLogar = ' Já tem uma conta?  Faça login '

export const titulo = ' Crie sua conta '

export const subTitulo = ' Comece sua jornada ! '

export const recursos = '🚀 Acesse todos os nossos recursos.'

export const comunidade = '🤝 Conecte-se com nossa comunidade.'

export const suporte = '📞 Suporte dedicado para ajudar você.'